<template>
  <a-modal class="date-modal-css" v-model="showModal" title="新增采购需求" width="1000px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" :model="formData">
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="加工组织"
            prop="organizationCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :value.sync="formData.organizationCode"
              selectType="selectAssemble"
              :selectData="inventOrg"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :assembleLabel="true"
              disabled
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="组装工单号"
            prop="wipEntityName"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              ref="wipEntityNameRef"
              :value.sync="formData.wipEntityName"
              selectType="selectSearch"
              requestApi="/mes/mesDiscreteJobs/allWipEntityName"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="wipEntityName"
              @change="handleWipEntity"
              :setParams="{ desOrganizationCode: formData.organizationCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="物料编码"
            prop="itemCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              v-if="formData.wipEntityName"
              ref="material2Ref"
              :value.sync="formData.itemCode"
              selectType="selectAssembleFilter"
              requestApi="/scp/scpPlanPurchaseOrder/getItemByWipEntityName"
              :selectItem="{ value: 'itemCode', label: 'itemName' }"
              searchParam="wipEntityName"
              :setParams="{ wipEntityName: formData.wipEntityName }"
            />
            <global-select
              v-else
              ref="materils"
              :value.sync="formData.itemCode"
              selectType="selectSearch"
              :dropdown-match-select-width="false"
              requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              searchParam="itemCode"
              sourseField="res"
              :totalNum="9999999999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="期望交货日期"
            prop="demandDate"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-date-picker style="width: 100%" v-model="formData.demandDate" valueFormat="YYYY-MM-DD 00:00:00" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="下单数量"
            prop="purchaseQuantity"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input-number
              style="width: 100%"
              v-model="formData.purchaseQuantity"
              :min="0.01"
              :max="999999"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="供应商编码"
            prop="supplierCode"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :dropdownMatchSelectWidth="false"
              :value.sync="formData.supplierCode"
              selectType="selectAssembleSearch"
              searchParam="supplierName"
              requestApi="/scp/scpProductionScheduling/findSupplier"
              :selectItem="{ value: 'lookUpCode', label: 'lookUpValue' }" />
<!--            <global-select
              v-model="formData.supplierCode"
              selectType="selectAssembleFilter"
              requestApi="/scp/scpPlanPurchaseOrder/supplierList"
              :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
              :setParams="{ orgCode: formData.organizationCode }"
            />-->
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpPlanPurchaseOrderCreate } from '@/api/scp/purchase/purchaseApi'
export default {
  name: 'AddPurchaseModal',
  data () {
    return {
      loading: false,
      showModal: false,
      formData: {
        itemCode: undefined, // 物料编码
        organizationCode: undefined, // 组织编码
        wipEntityName: undefined, // 组装工单号
        demandDate: undefined, // 期望交货日期
        purchaseQuantity: undefined, // 采购数量
        supplierCode: undefined // 供应商编码
      }
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    // 展示
    show(organizationCode) {
      this.reset()
      this.formData.organizationCode = organizationCode
      this.showModal = true
    },
    // 取消
    onCancel() {
      this.showModal = false
    },
    // 重置
    reset() {
      this.formData = {
        itemCode: undefined, // 物料编码
        organizationCode: undefined, // 组织编码
        wipEntityName: undefined, // 组装工单号
        demandDate: undefined, // 期望交货日期
        purchaseQuantity: undefined, // 采购数量
        supplierCode: undefined // 供应商编码
      }
      if(this.$refs?.wipEntityNameRef) this.$refs.wipEntityNameRef.handleSearch('');
    },
    // 来源工单选择
    handleWipEntity() {
      this.$set(this.formData, 'itemCode', '')
    },
    // 提交
    onSubmit() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          this.loading = true
          apiScpPlanPurchaseOrderCreate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('新增成功')
              this.$emit('success')
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
